<template>
  <div class="row gap-1 d-flex justify-content-end">
    <!-- <router-link class="d-inline-block w-auto px-0" :to="{
      name: 'new-project',
      params: { parentId: this.$route.params?.projectId }
    }">
      <span class="btn btn-sm btn-primary d-flex">
        Subgroep toevoegen
        <span class="material-icons-round ms-2">
          add
        </span>
      </span>
    </router-link> -->

    <router-link class="d-inline-block w-auto px-0" :to="{
      name: 'edit-project',
      params: { projectId: this.$route.params?.projectId }
    }">
      <span class="btn btn-sm btn-primary d-flex">
        Groep aanpassen
        <span class="material-icons-round ms-2">
          edit_note
        </span>
      </span>
    </router-link>
  </div>

  <h3>Subgroepen</h3>

  <div class="row">
    <ProjectCard :project-id="parentId" title="Nieuw" sub-title="Test" isNew />

    <ProjectCard v-for="project in childProjects" :key="project.id" :title="project.title" :sub-title="project.subTitle"
      :project-id="project.id" :image="project.visualImage" />
  </div>

  <h3>Berichten</h3>

  <div class="row">
    <ProjectItemCard description="Klik op de button om een projectitem toe te voegen" featured :is-new-item="false"
      :image="require('@/assets/img/events/meeting.webp')" />

    <ProjectItemCard v-for="projectItem in projectItems" :key="projectItem.id" :project-item-id="projectItem.id"
      :title="projectItem.title" :description="projectItem.description" :pinned-date="projectItem.pinnedDate"
      :create-date="projectItem.createDate" :image="projectItem.visualImage" />
  </div>
</template>

<script>
import { get } from '@/api/providers/projects';
import { getAll } from '@/api/providers/projectItems';
import ProjectCard from '@/components/Projects/Card.vue';
import ProjectItemCard from '@/components/ProjectOverview/Card.vue';

export default {
  name: 'ProjectOverview',

  components: {
    ProjectCard,
    ProjectItemCard,
  },

  data: () => ({
    childProjects: [],
    projectItems: [],
  }),

  watch: {
    '$route.params.projectId'(current, old) {
      if (current == null) return;

      if (current != old) {
        this.loadChildProjects();
        this.loadProjectItems();
      }
    }
  },

  created() {
    this.loadChildProjects();
    this.loadProjectItems();
  },

  computed: {
    parentId() {
      return this.$route.params.projectId
    }
  },

  methods: {
    loadChildProjects() {
      get(this.$route.params.projectId)
        .then((project) => {
          this.childProjects = project.children ?? [];
        })
    },
    loadProjectItems() {
      getAll(this.$route.params.projectId)
        .then((items) => {
          this.projectItems = items
        })
        .catch((error) => error.default());
    },
  },
};
</script>
